export enum CustomerTypeEnum {
  Unknown,
  Franchise,
  Independent,
  Lease
}
